// extracted by mini-css-extract-plugin
export default {"card":"Dt9P9RT"};